import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwlCarousel } from './owl-carousel.component';
import { OwlChild } from './owl-child.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    OwlCarousel, OwlChild
  ],
  // The original module exported only OwlCarousel (OwlChild is internal to its template).
  exports: [
    OwlCarousel
  ]
})
export class OwlModule {}
